import { getErrorMessage } from "../utils/commonUtils";
import {
  useCreateVendorMutation,
  useDeleteVendorMutation,
  useDuplicateVendorMutation,
  useEditVendorMutation,
  useGetVendorMutation,
  useSetVendorStatusActiveMutation,
  useSetVendorStatusDeActiveMutation,
} from "../redux/vendor/vendorApiSlice";
import {
  useGetMckessonVendorDetailMutation,
  useGetMckessonShippingLocationsMutation,
  useGetMckessonApisMutation,
  usePostMckessonApiMutation,
  usePutMckessonApiMutation,
  useDeleteMckessonApiMutation,
  usePostMckessonVendorDetailMutation,
  usePutMckessonVendorDetailMutation,
  usePostMckessonShippingLocationMutation,
  usePutMckessonShippingLocationMutation,
  useDeleteMckessonShippingLocationMutation,
} from "../redux/mckesson/mckessonApiSlice";
import { toast } from "react-toastify";

export default function useVendor() {
  const [getVendor, { isLoading: getVendorsLoading }] = useGetVendorMutation();
  const [createVendor, { isLoading: createVendorLoading }] =
    useCreateVendorMutation();
  const [editVendor, { isLoading: editVendorLoading }] =
    useEditVendorMutation();
  const [deleteVendor, { isLoading: deleteVendorLoading }] =
    useDeleteVendorMutation();
  const [setVendorStatusActive, { isLoading: setVendorStatusActiveLoading }] =
    useSetVendorStatusActiveMutation();
  const [
    setVendorStatusDeActive,
    { isLoading: setVendorStatusDeActiveLoading },
  ] = useSetVendorStatusDeActiveMutation();
  const [duplicateVendor, { isLoading: duplicateVendorLoading }] =
    useDuplicateVendorMutation();
  const [getMckessonVendorDetail, { isLoading: getMckessonVendorDetailLoading }] =
    useGetMckessonVendorDetailMutation();
  const [getMckessonShippingLocations, { isLoading: getMckessonShippingLocationsLoading }] =
    useGetMckessonShippingLocationsMutation();
  const [getMckessonApis, { isLoading: getMckessonApisLoading }] =
    useGetMckessonApisMutation();
  const [postMckessonApi, { isLoading: postMckessonApiLoading }] =
    usePostMckessonApiMutation();
  const [putMckessonApi, { isLoading: putMckessonApiLoading }] =
    usePutMckessonApiMutation();
  const [deleteMckessonApi, { isLoading: deleteMckessonApiLoading }] =
    useDeleteMckessonApiMutation();
  const [postMckessonVendorDetail, { isLoading: postMckessonVendorDetailLoading }] =
    usePostMckessonVendorDetailMutation();
  const [putMckessonVendorDetail, { isLoading: putMckessonVendorDetailLoading }] =
    usePutMckessonVendorDetailMutation();
  const [postMckessonShippingLocation, { isLoading: postMckessonShippingLocationLoading }] =
    usePostMckessonShippingLocationMutation();
  const [putMckessonShippingLocation, { isLoading: putMckessonShippingLocationLoading }] =
    usePutMckessonShippingLocationMutation();
  const [deleteMckessonShippingLocation, { isLoading: deleteMckessonShippingLocationLoading }] =
    useDeleteMckessonShippingLocationMutation();
  const getVendorsAPI = async (data: any) => {
    try {
      const response: any = await getVendor(data).unwrap();
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };

  const createVendorAPI = async (data: any) => {
    try {
      const response: any = await createVendor(data).unwrap();
      return response;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const activeVendorAPI = async (data: any) => {
    try {
      const response: any = await setVendorStatusActive(data).unwrap();
      toast.success("Success! Vendor has been Activated.");
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const deactiveVendorAPI = async (data: any) => {
    try {
      const response: any = await setVendorStatusDeActive(data).unwrap();
      toast.success("Success! Vendor has been Deactivated.");
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const editVendorAPI = async (data: any) => {
    try {
      const response: any = await editVendor(data).unwrap();
      return response;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const deleteVendorAPI = async (data: any) => {
    try {
      const response: any = await deleteVendor(data).unwrap();
      toast.success("Success! Vendor has been Deleted.");
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const duplicateVendorAPI = async (data: any) => {
    try {
      const response: any = await duplicateVendor(data).unwrap();
      toast.success("Success! Vendor has been Duplicated.");
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const getMckessonVendorDetailAPI = async () => {
    try {
      const response: any = await getMckessonVendorDetail({}).unwrap();
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };

  const getMckessonApisAPI = async () => {
    try {
      const response: any = await getMckessonApis({}).unwrap();
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };

  const postMckessonApiAPI = async (data: any) => {
    try {
      const response: any = await postMckessonApi(data).unwrap();
      toast.success("Success! URL has been Added.");
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };

  const putMckessonApiAPI = async (data: any) => {
    try {
      const response: any = await putMckessonApi(data).unwrap();
      toast.success("Success! URL has been Updated.");
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };

  const deleteMckessonApiAPI = async (data: any) => {
    try {
      const response: any = await deleteMckessonApi(data).unwrap();
      toast.success("Success! URL has been Deleted.");
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };

  const postMckessonVendorDetailAPI = async (data: any) => {
    try {
      const response: any = await postMckessonVendorDetail(data).unwrap();
      toast.success("Success! Vendor Settings have been Saved.");
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };

  const putMckessonVendorDetailAPI = async (data: any) => {
    try {
      const response: any = await putMckessonVendorDetail(data).unwrap();
      toast.success("Success! Vendor Settings have been Updated.");
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };

  const postMckessonShippingLocationAPI = async (data: any) => {
    try {
      const response: any = await postMckessonShippingLocation(data).unwrap();
      toast.success("Success! Shipping Location has been Added.");
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };

  const putMckessonShippingLocationAPI = async (data: any) => {
    try {
      const response: any = await putMckessonShippingLocation(data).unwrap();
      toast.success("Success! Shipping Location has been Updated.");
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };

  const deleteMckessonShippingLocationAPI = async (data: any) => {
    try {
      const response: any = await deleteMckessonShippingLocation(data).unwrap();
      toast.success("Success! Shipping Location has been Deleted.");
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };

  const getMckessonShippingLocationsAPI = async () => {
    try {
      const response: any = await getMckessonShippingLocations({}).unwrap();
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };


  return {
    getVendorsAPI,
    getVendorsLoading,
    createVendorLoading,
    createVendorAPI,
    editVendorAPI,
    editVendorLoading,
    deleteVendorAPI,
    deleteVendorLoading,
    activeVendorAPI,
    setVendorStatusActiveLoading,
    deactiveVendorAPI,
    setVendorStatusDeActiveLoading,
    duplicateVendorLoading,
    duplicateVendorAPI,
    getMckessonVendorDetailAPI,
    getMckessonVendorDetailLoading,
    getMckessonShippingLocationsAPI,
    getMckessonShippingLocationsLoading,
    getMckessonApisAPI,
    getMckessonApisLoading,
    postMckessonApiAPI,
    postMckessonApiLoading,
    putMckessonApiAPI,
    putMckessonApiLoading,
    deleteMckessonApiAPI,
    deleteMckessonApiLoading,
    postMckessonVendorDetailAPI,
    postMckessonVendorDetailLoading,
    putMckessonVendorDetailAPI,
    putMckessonVendorDetailLoading,
    postMckessonShippingLocationAPI,
    postMckessonShippingLocationLoading,
    putMckessonShippingLocationAPI,
    putMckessonShippingLocationLoading,
    deleteMckessonShippingLocationAPI,
    deleteMckessonShippingLocationLoading,
  };
}
